import { LocalService } from './../../services/storage/localService';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { DeudasService } from 'app/services/cobranzas/deudas/deudas.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginService } from 'app/services/login/login.service';
import { Router } from '@angular/router';
import { FacturacionCPEService } from './../../services/facturacion-cpe/facturacion-cpe.service';
import { CpeDetalle } from './../../models/cpeDetalle';
import { Validators,FormGroup,FormControl } from '@angular/forms';
import Swal from "sweetalert2";
import { Component, OnInit, Output, EventEmitter,ElementRef, ViewChild,Injector } from '@angular/core';
import { formatDate,DatePipe } from '@angular/common';
import * as moment from 'moment';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { MessagesTitles, MessagesStatus } from '../../models/messages';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';

import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  MatDatepickerInputEvent,
} from "@angular/material";
import { FiltrosCPE } from 'app/models/FiltrosCPE';
import { environment } from 'environments/environment';

export const MY_FORMATS  ={
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-nuevo-cpe',
  templateUrl: './nuevo-cpe.component.html',
  styleUrls: ['./nuevo-cpe.component.scss'],
  providers:[MessagesTitles, MessagesStatus,DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class NuevoCpeComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  Id_IGV_Exonerado=environment.ID_IGV_Exonerado;
  Id_IGV_No_Exonerado=environment.ID_IGV_No_Exonerado;
  IGV_Porcentaje:any; 

  @Output() 
  dateChange:EventEmitter< MatDatepickerInputEvent< any>>;

  minDate = moment().add(-3, 'day');
  maxDate = new Date();
  dateMinV = this.maxDate;
  minDateV = this.dateMinV;

  FacturacionDetalle : [];
  SubTotal:number = 0;
  UniIGV:number = 0;
  Igv:number = 0;
  Total:number = 0;
  abrirDetalle : boolean = false;
  ArrayDetalle :CpeDetalle[]=[];
  form : FormGroup;
  now = moment();
  view : boolean;
  FechaV = formatDate(new Date(), 'yyyy-MM-dd', 'en')
  tipoOperacionElement=111;
  tipoPagoCPEElement=114;

  id;
  idCli ="" ;
  RUC_CLI : string;
  cliId = new FormControl();
  filteredCliente: Observable<any[]>;
  clientesArr;
  DTOFiltrosCPE: FiltrosCPE = new FiltrosCPE();
  monedaElement:any;
  signoMoneda= "S/";
  Observaciones: string = "";
  CPETemporal: any = {}

  str :any;  
  rCliCombo:any; 
  search:boolean;
  dataCorreos: any =[];
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  correoCrt = new FormControl('',[Validators.required]);
  filteredCorreos: Observable<string[]>;
  correos: string[] = [];
  allprueba:string[]=[];
  gravada:number = 0;
  noGravada:number = 0;

  @ViewChild('correoInput',{static: true}) correoInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto2',{static: true}) matAutocomplete: MatAutocomplete;
  cpeService:FacturacionCPEService;
  loginService:LoginService;
  empresasService:EmpresasService;
  localService : LocalService;
  deudasService:DeudasService;
  constructor(
              private injector:Injector,
              private datepipe :DatePipe,
              private router:Router,
              private msgTitulos : MessagesTitles,
              private msgStatus:MessagesStatus
              ) { 
    this.cpeService = this.injector.get<FacturacionCPEService>(FacturacionCPEService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.localService = this.injector.get<LocalService>(LocalService);
    this.empresasService = this.injector.get<EmpresasService>(EmpresasService);
    this.deudasService = this.injector.get<DeudasService>(DeudasService);
    this.IGV_Porcentaje = this.localService.getJsonValue('ParametroIGVPorcentaje');
    if (this.cpeService.TipoCambio == undefined) {
      this.loginService.clickGuard = true;
      this.router.navigate(['/facturacion/factura/listado']);
    }
  
    this.ObtenerClienteCombo();
    this.obtenerProductos()
    
    this.form = new FormGroup({
      TipoComprobante :new FormControl({value:'F',disabled: true},[Validators.required]),
      Establecimiento :new FormControl({value:1,disabled: true},[Validators.required]),
      TipoOperacion : new FormControl({value:111,disabled: true},[Validators.required]),
      Serie :new FormControl({value:'F002',disabled: false},[Validators.required]),
      Moneda :new FormControl({value:2,disabled: false},[Validators.required]),
      Cliente :new FormControl('',[Validators.required]),
      TipoPago :new FormControl({value:114,disabled: true},[Validators.required]),
      FechaEmision :new FormControl(this.now,[Validators.required]),
      FechaVencimiento :new FormControl(this.now,[Validators.required]),
      TipoCambio :new FormControl({value:this.cpeService.TipoCambio[0].Compra,disabled: true},[Validators.required])
    });
  }

  ngOnInit() {
    this.DTOFiltrosCPE.Moneda = this.Label_id_soles;
    this.monedaElement = this.Label_id_soles;
  }

  tipoMoneda(event){
    this.DTOFiltrosCPE.Moneda = event;
    this.form.controls['Moneda'].setValue(event);

    if(this.DTOFiltrosCPE.Moneda == this.Label_id_dolares){
      this.signoMoneda = "$"      
    }else if(this.DTOFiltrosCPE.Moneda == this.Label_id_soles){
      this.signoMoneda = "$"
    }else if(this.DTOFiltrosCPE.Moneda == 106){
      this.signoMoneda = '€'
    }
  }

  changeMinDate() {  
    this.form.controls['FechaVencimiento'].setValue(this.form.controls['FechaEmision'].value)
    this.minDateV = this.form.controls['FechaEmision'].value;
  }

  addProduct(){
    this.abrirDetalle = true;
    this.form.controls['FechaEmision'].setValue(this.datepipe.transform(this.form.controls['FechaEmision'].value,'yyyy-MM-dd'));
    this.form.controls['FechaVencimiento'].setValue(this.datepipe.transform(this.form.controls['FechaVencimiento'].value,'yyyy-MM-dd'));
  }

  tipoOperacion(event){
    this.form.controls['TipoOperacion'].setValue(event);
  }

  tipoPagoCPE(event){
    this.form.controls['TipoPago'].setValue(event);
  }

  eliminarItem(i : number,IGV_Porcentaje,total){
    if(IGV_Porcentaje == "0.00"){
      this.noGravada = this.noGravada-total;
    }    
    this.ArrayDetalle.splice(i,1);
    this.calcular();
  }

  RecibirDetalle(event){
    this.ArrayDetalle.push(event);
    this.abrirDetalle = false;
    this.view = true; 
    this.calcular();
  }

  CerrarDetalle(){
    this.abrirDetalle = false;
  }

  calcular(){
    this.SubTotal = 0;
    this.Igv = 0;
    this.Total = 0;
    this.noGravada = 0;
    this.gravada = 0;
    for (let item of this.ArrayDetalle){
      this.SubTotal += item.Cantidad * item.Valor_Unitario;
      this.Igv += (item.Cantidad*item.Valor_Unitario)*item.IGV_Porcentaje;
      this.Total = Math.round((item.Total+this.Total)*100)/100;
      if(item.IGV_Porcentaje == "0.00"){
        this.noGravada += item.Cantidad * item.Valor_Unitario;
      }else{
        this.gravada += (item.Cantidad * item.Valor_Unitario)*(1+ Number(item.IGV_Porcentaje));
      }
    } 
  }

  Generar(){
    this.str = this.correos.join(";")
    this.CPETemporal.Detalle =[];
    this.CPETemporal.idLocal = 1;
    this.CPETemporal.Establecimiento = this.form.controls['Establecimiento'].value;
    this.CPETemporal.Tipo_Operacion = this.form.controls['TipoOperacion'].value;
    this.CPETemporal.Tipo_Pago = this.form.controls['TipoPago'].value;
    this.CPETemporal.Tipo_Comprobante = this.form.controls['TipoComprobante'].value;
    this.CPETemporal.Serie = this.form.controls['Serie'].value;
    this.CPETemporal.Fecha_Emision = this.datepipe.transform(this.form.controls['FechaEmision'].value,'yyyy-MM-dd');
    this.CPETemporal.Fecha_Vencimiento = this.datepipe.transform(this.form.controls['FechaVencimiento'].value,'yyyy-MM-dd');
    this.CPETemporal.Moneda = this.form.controls['Moneda'].value;
    this.CPETemporal.Valor_Venta = this.SubTotal;
    this.CPETemporal.IGV_Exonerado = this.Id_IGV_No_Exonerado;
    this.CPETemporal.IGV_Porcentaje = this.IGV_Porcentaje;
    this.CPETemporal.IGV_Importe = this.Igv;
    this.CPETemporal.Precio_Venta = this.Total;
    this.CPETemporal.Correo = this.str;
    this.CPETemporal.Observacion = this.Observaciones;
    this.CPETemporal.Operaciones_Grabadas = this.gravada;
    this.CPETemporal.Operaciones_Inafectas = this.noGravada;

    for (const item of this.ArrayDetalle) {
      this.CPETemporal.Detalle.push(item)
    }
 
    Swal.fire({
      title: "Espere...",
      text: "Guardando la información.",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading()
    this.cpeService.GuardarCPEFactura(this.CPETemporal).subscribe(
      resp => {
        Swal.fire({
          title: "¡Éxito!",
          text: "CPE guardado correctamente.",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(res =>{
          if (res.value == true ){ 
            this.loginService.clickGuard = true;
            this.router.navigate(['/facturacion/factura/listado']);           
          }
        });
    },(err: HttpErrorResponse)=> {
      
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
    } else {
        this.msgStatus.getMessage(err.status);            
    }
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "CPE NO GUARDADO. "+this.msgStatus.message ,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
    });

  }

  EnterobtenerRucRazSocialCli(termino :string = ''){
    let RUCempresa = '';
    let idCliente = '';
    let Tipo_Doc_Identificacion = '';
    let Razon_Social = '';
    let Direccion_Fiscal = '';
    if (termino != null && termino != ''){
      let termino1 = termino.toLowerCase();                   
      for( let p of this.clientesArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.id = p.idEmpresa;
            RUCempresa =p.Num_Doc_Identificacion;
            idCliente = p.idEmpresa;
            Tipo_Doc_Identificacion = p.Tipo_Doc_Identificacion;
            Razon_Social = p.Razon_Social;
            Direccion_Fiscal = p.Direccion_Fiscal;
          }
      }

      this.form.controls['Cliente'].setValue( RUCempresa);
      this.CPETemporal.idCliente = idCliente;
    }
    this.LimpiarRepresentantes();

  }

  obtenerId(cliId :string){

    this.CPETemporal.idCliente = cliId;
    this.form.controls['Cliente'].setValue(cliId);
    this.LimpiarRepresentantes();
  }

  ObtenerClienteCombo() {
    this.clientesArr = JSON.parse(sessionStorage.getItem('lstCliCbo'));
      this.filteredCliente = this.cliId.valueChanges.pipe(
        startWith(""),
        map(state => state ? this._filterCli(state) : this.clientesArr.slice()
        )
      );
  }
  private _filterCli(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.clientesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  obtenerProductos(){
    this.deudasService.obtenerProductos().subscribe(res =>{
      this.cpeService.Productos = res
    })
  }

 public ListarRepresentantesProv(){
  this.idCli = this.CPETemporal.idCliente;
  if (this.idCli=='' || this.idCli== '0') {
    return
  }
  if (this.search) {
    this.idCli = this.CPETemporal.idCliente;
    this.empresasService.obtenerContactosEmpresa(this.idCli).subscribe(
      res => { 
          this.search = false;      
          this.rCliCombo = res;

          this.rCliCombo = this.rCliCombo.filter(
            state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 
          );
          this.dataCorreos = this.rCliCombo
          for(let item of this.dataCorreos){
            this.allprueba.splice(1,0,item.Correo);
          }
        this.filteredCorreos = this.correoCrt.valueChanges.pipe(
        startWith(null),
        map((fruit: string | null) => fruit ? this._filter(fruit) : this.allprueba.slice()));
      },(err: HttpErrorResponse)=> {
      
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
      } else {
          this.msgStatus.getMessage(err.status);            
      }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "REPRESENTANTES no encontrado. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      });
  }else{
    return;
  }  
  }

   add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim() && this.correos.length < 3) {
      this.correos.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
    this.correoCrt.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.correos.indexOf(fruit);
    if (index >= 0) {
      this.correos.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.correos.length < 3) {
    this.correos.push(event.option.viewValue);
    this.correoInput.nativeElement.value = '';
    this.correoCrt.setValue(null);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allprueba.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  LimpiarRepresentantes(){
    this.search = true;
    this.allprueba.splice(0,this.allprueba.length);
    this.correos.splice(0,this.correos.length);
    this.correoCrt.setValue('');
  }

}
